module.exports = __webpack_public_path__ + "static/media/Double Ring-1s-200px.e7854601.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Double Ring-1s-200px.svg
// module id = 82
// module chunks = 8